<div class="fx--v">
  <div class="required-fields">
    <span class="required-icon">&#x2a;</span>
    <span>Required Fields</span>
  </div>

  <form [formGroup]="form" class="fx fx--wrap form-container form-container__gap">
    <ng-container *ngFor="let column of columns | hideControls: isStatistical : user; trackBy: columnField">
      <div class="form-input fx--v" [ngClass]="{ 'form-input__double': column.inputType === 'TextArea' }">
        <label class="miq-form-input-label" [ngClass]="{ 'miq-form-input-label--required': column.required }">
          {{ column.header }}
        </label>

        <ng-container [ngSwitch]="column?.inputType">
          <!-- TBD -->
          <mat-form-field *ngSwitchCase="'Dropdown'" appearance="outline">
            <mat-select [formControlName]="column.field" hideSingleSelectionIndicator panelClass="custom-dropdown">
              <mat-option *ngFor="let option of column?.values" [value]="option.key">
                {{ option.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field *ngSwitchCase="'TextArea'" appearance="outline">
            <!-- TBD -->
            <textarea matInput [formControlName]="column.field" autocomplete="no-autofill"></textarea>
          </mat-form-field>

          <mat-form-field *ngSwitchDefault appearance="outline">
            <!-- autocomplete -->
            <ng-container *ngIf="column.values?.length > 0; else defaultInput">
              <input matInput type="text" [formControlName]="column.field" [matAutocomplete]="auto" />
              <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption hideSingleSelectionIndicator>
                <mat-option *ngFor="let option of column.values" [value]="option.key">
                  {{ option.value | uppercase }}
                </mat-option>
              </mat-autocomplete>
            </ng-container>
            <!-- normal input -->
            <ng-template #defaultInput>
              <input matInput type="text" [formControlName]="column.field" />
            </ng-template>
          </mat-form-field>
        </ng-container>
      </div>
    </ng-container>
  </form>
</div>
